import { ILocationModelJSON, Location, LocationsModel, TLocation, TLocationsModel } from './LocationsModel'

export const sampleLocation: ILocationModelJSON = {
  _id: 'L123',
  organizationId: 'O123',
  name: 'test test location',
  contactIds: ['C123', 'C234'],
  place: {
    _id: 'P123',
    types: ['air', 'sea'],
    name: 'Port Hamburg',
    countryCode: 'DE',
    location: {
      type: 'Point',
      coordinates: [123, 456],
    },
    companyName: 'Forto',
  },
  notes: 'hello hello',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
}

export function getLocation(props?: Partial<ILocationModelJSON>): TLocation {
  return Location.create({ ...sampleLocation, ...props })
}

export function getLocationsModel(): TLocationsModel {
  return LocationsModel.create({
    data: [sampleLocation],
    total: 1,
  })
}
